import { IdentityProviderSettingsFormData } from '../../../integrated-client/models';

export type IIdentityProviderSettingsFormData = IdentityProviderSettingsFormData;

export interface IEditorData {
  identityProviderSettingsData?: IIdentityProviderSettingsFormData;
  validation?: any;
  readyToSave?: boolean;
}

export class EditorData implements IEditorData {
  identityProviderSettingsData?: IIdentityProviderSettingsFormData;
  validation?: any;
  readyToSave?: boolean;

  constructor() {    
    this.identityProviderSettingsData = { disabled: false } as IIdentityProviderSettingsFormData;
    this.readyToSave = false;
  }
}
